import { differenceInCalendarDays, format } from 'date-fns';

const ACTIVE_DAYS = 21;

export default class DateUtil {
  static formatDate(date, dateFormat: string = 'T') {
    return format(date, dateFormat);
  }

  static isActiveDeveloper(date: Date): boolean {
    return differenceInCalendarDays(new Date(), date) < ACTIVE_DAYS;
  }

  static getMillisecondDate(timestamp: number): Date {
    return new Date(timestamp * 1000);
  }

  static getTimestampInSeconds(date: Date): number {
    return Math.floor(date.getTime() / 1000);
  }

  static formatDuration(ms: number): string {
    const totalSeconds = ms / 1000;

    const years = Math.floor(totalSeconds / (365 * 24 * 60 * 60));
    const weeks = Math.floor((totalSeconds % (365 * 24 * 60 * 60)) / (7 * 24 * 60 * 60));
    const days = Math.floor((totalSeconds % (7 * 24 * 60 * 60)) / (24 * 60 * 60));
    const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    let result = '';
    if (years) { result += `${years}y `; }
    if (weeks) { result += `${weeks}w `; }
    if (days) { result += `${days}d `; }
    // if (hours && !years) result += `${hours}h `;
    // if (minutes && !years && !weeks) result += `${minutes}m `;
    // if (seconds && !years && !weeks && !days) result += `${seconds}s`;

    return result.trim() || '0s';
  }
}
